if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        if (this.querySelector("form")) {
          this.form = this.querySelector("form");
          this.form.querySelector("[name=id]").disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        } else {
          this.querySelector("[name=id]").disabled = false;
          this.querySelector("button[type=submit]").addEventListener(
            "click",
            this.onSubmitHandler.bind(this)
          );
        }

        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner")?.classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (!this.form) {
          formData.append("id", this.querySelector("[name=id]").value);
        }

        const mainVariantId = formData.get("id");
        const mainQuantity = Number(formData.get("quantity") || 1);
        const care =
          this.closest(".product__info-container")?.querySelector("qeydo-care") ||
          this.closest(".product")?.querySelector("qeydo-care") ||
          this.closest("[data-product-model]")?.querySelector("[data-qeydo-care-card]") ||
          this.closest(".card-wrapper")?.querySelector("[data-qeydo-care-card]") ||
          this.closest("section")?.querySelector("qeydo-care");
        const careCheckbox = care?.querySelector("[data-qeydo-care-checkbox]");
        const addCare = Boolean(careCheckbox?.checked && care?.dataset.careVariantId);

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const accessoryItems = this.querySelector("qeydo-accessory-options")
          ?.selectedItems(mainQuantity) || [];
        if (addCare || accessoryItems.length) {
          const productProperties = {};
          formData.forEach((value, key) => {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && value !== "") productProperties[match[1]] = value;
          });
          const items = [{
            id: Number(mainVariantId),
            quantity: mainQuantity,
            properties: productProperties,
            ...(formData.get("selling_plan") ? { selling_plan: formData.get("selling_plan") } : {}),
          }];
          if (addCare) {
            const linkId = `qeydo-care-${Date.now()}-${mainVariantId}`;
            productProperties._qeydo_care_link = linkId;
            productProperties._qeydo_care_selected = "true";
            items.push({
              id: Number(care.dataset.careVariantId),
              quantity: mainQuantity,
              properties: {
                "Produit couvert": care.dataset.productTitle,
                _qeydo_care_link: linkId,
                _qeydo_care_for_variant: String(mainVariantId),
              },
            });
          }
          items.push(...accessoryItems);

          config.headers["Content-Type"] = "application/json";
          config.body = JSON.stringify({
            items,
            ...(this.cart
              ? {
                  sections: this.cart.getSectionsToRender().map((section) => section.id),
                  sections_url: window.location.pathname,
                }
              : {}),
          });
        } else {
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            // CART ERROR EVENT
            if (response.status) {
              document.dispatchEvent(
                new CustomEvent("cart:error", {
                  detail: {
                    source: this.dataset.source,
                    productVariantId: mainVariantId,
                    errors: response.description,
                    message: response.message,
                  },
                })
              );
              // -------------------------------------------
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: mainVariantId,
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage || accessoryItems.length) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // VARIANT ADDED EVENT
            document.dispatchEvent(
              new CustomEvent("variant:add", {
                detail: {
                  variant: {
                    id: mainVariantId,
                  },
                  quantity: mainQuantity,
                  formElement: this.form,
                  sectionId: this.dataset.source,
                },
              })
            );
            // -------------------------------------------

            fetch(`${routes.cart_url}.js`)
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                const parsedState = JSON.parse(state);

                // dispatch cart:change for the entire basket
                document.dispatchEvent(
                  new CustomEvent("cart:change", {
                    detail: {
                      cart: parsedState,
                      sectionId: this.dataset.source,
                    },
                  })
                );
                // dispatch cart:change for the entire basket
              })
              .catch((error) => {
                console.error("Error fetching cart state:", error);
              });

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: mainVariantId,
              });
            this.error = false;
            const quickAddModal = this.closest("qeydo-quick-view, quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              const doorCompatibilityDialog = this.closest(
                "dialog[data-product-dialog]"
              );

              if (doorCompatibilityDialog?.open) {
                // A native <dialog> and its backdrop sit above the cart drawer.
                // Close it first, then render/open the drawer on the next paint
                // so the shopper immediately sees the updated cart.
                doorCompatibilityDialog.close();
                window.requestAnimationFrame(() => {
                  window.requestAnimationFrame(() => {
                    this.cart.renderContents(response);
                  });
                });
              } else {
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner")?.classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

if (!customElements.get("qeydo-accessory-options")) {
  customElements.define("qeydo-accessory-options", class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest("form");
      this.buyArea = this.closest(".product__buy-buttons");
      if (!this.form || !this.buyArea) return;
      this.prices = JSON.parse(this.querySelector("[data-lock-prices]").textContent);
      this.cards = Array.from(this.querySelectorAll("[data-addon]"));
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.buyArea.addEventListener("change", () => this.update(), { signal });
      this.buyArea.addEventListener("input", (event) => {
        if (event.target.name === "quantity") this.update();
      }, { signal });
      this.hidden = false;
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    selectedItems(quantity) {
      return this.cards.flatMap((card) => {
        const pack = card.querySelector("input[type=radio]:checked:not(:disabled)");
        if (!card.querySelector("[data-addon-toggle]").checked || !pack) return [];
        return [{ id: Number(pack.value), quantity }];
      });
    }

    update() {
      let accessoryPrice = 0;
      let hasSelection = false;
      for (const card of this.cards) {
        const selected = card.querySelector("[data-addon-toggle]").checked;
        const pack = card.querySelector("input[type=radio]:checked:not(:disabled)");
        const fieldset = card.querySelector("[data-addon-packs]");
        fieldset.hidden = !selected || fieldset.querySelectorAll("input").length < 2;
        if (!pack) continue;
        card.querySelector("[data-addon-price]").textContent = pack.dataset.priceLabel;
        if (selected) {
          hasSelection = true;
          accessoryPrice += Number(pack.dataset.price);
        }
      }

      const total = this.querySelector(".qeydo-addons__total");
      const variant = this.form.elements.namedItem("id")?.value;
      const price = this.prices[variant];
      total.hidden = !hasSelection || price == null;
      if (total.hidden) return;
      const quantity = Math.max(1, Number(this.form.elements.namedItem("quantity")?.value) || 1);
      const care = this.buyArea.querySelector("qeydo-care");
      const carePrice = care?.querySelector("[data-qeydo-care-checkbox]")?.checked
        ? Number(care.dataset.carePrice) || 0
        : 0;
      const amount = (price + accessoryPrice + carePrice) * quantity / 100;
      const formatted = new Intl.NumberFormat("fr-MA", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
      this.querySelector("[data-addon-total]").textContent = `${formatted} MAD`;
      total.querySelector("span").textContent = carePrice
        ? "Total avec accessoires et Care+"
        : "Total avec accessoires";
    }
  });
}
